// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"11ef8799","147":"a95a7d1e","374":"6de8e5cf","453":"6e726290","496":"6b9e7845","599":"c76e9e04","749":"27652e3c","780":"59a0c345"}[chunkId] + ".chunk.js";
};